import request from './request';
import {property} from 'lodash';

export function fetchSubject(chatId) {
	return request(`/chats/${chatId}`)
		.then(property('chat.subject'));
}
